import axios from '@axios'

const group = 'report/'
const route = 'report_commission'

export default {
  namespaced: true,
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {

    index(context, {
      date_start, date_end, itemsPerPage, page, search, filters,
    }) {
      return axios.post(`${group + route}?date_start=${date_start
      }&date_end=${date_end
      }&page=${page
      }&items_per_page=${itemsPerPage}`, filters)
    },

    getExportExcel(constext, data) {
      return axios.post(`${group + route}/export_excel`, data, { responseType: 'blob' })
    },

    getExportPdf(constext, data) {
      return axios.post(`${group + route}/export_pdf`, data, { responseType: 'blob' })
    },

  },

}
